export default "__VITE_ASSET__DeQX5Aa___"